import SettingsView from './SettingsView.vue'

export default SettingsView;
